import { IdNameCombination } from "./IdNameCombination";

export class IdNameColorModel extends IdNameCombination {
    Color: string;

    constructor(id: number, name: string, color: string) {
        super(id, name);
        this.Color = color;
    }
}